import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from '../../dynamicComponent';
import {ConfigNameValue as NameValue} from 'componentLibrary';
import {Form, Grid, Loader, Header, Segment, ItemGroup} from 'semantic-ui-react';
import {
  InlineTextAreaField,
  Checkbox,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {ISOToDisplayDate} from 'common/utils';
import _ from 'lodash';
import produce from 'immer';

export class SamGovProfile extends React.Component {
  constructor(props) {
    super(props);
    this.blankModel = {
      bankAccountReviewCheck: false,
      isDelinquent: {
        explanation: '',
      },
    };
    this.state = {
      model: {
        bankAccountReviewCheck: false,
        isDelinquent: {
          explanation: '',
        },
      },
    };
  }

  componentDidMount() {
    if (!_.isEmpty(this.props.data)) {
      this.setState({model: this.props.data});
    }
    const currentOrg = _.get(this.props, 'organization', {});
    if (
      !_.isEmpty(currentOrg) &&
      !currentOrg.loading &&
      _.toLower(_.get(currentOrg, 'isManuallyAdded', '')) !== 'y'
    ) {
      this.setState({currentOrg: currentOrg});
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.data, this.props.data)) {
      this.setState({model: this.props.data});
    }
    const currentOrg = _.get(this.props, 'organization', {});
    const prevCurrentOrg = _.get(prevProps, 'organization', {});
    if (!_.isEqual(prevCurrentOrg, currentOrg)) {
      this.setState({currentOrg: currentOrg});
    }
  }

  saveSamGovInfo = (fieldName) => {
    const {saveEntityData, entityDataPath, entityType, validationId} = this.props;
    saveEntityData(
      entityDataPath,
      entityType,
      this.state.model,
      validationId + '.' + fieldName
    );
  };

  handleBankReviewChange = (name, value) => {
    let model = _.cloneDeep(this.state.model);
    _.set(model, name, value);
    this.setState({model: model}, () => {
      this.saveSamGovInfo('bankAccountReviewCheck');
    });
  };

  renderOrg = () => {
    const {currentOrg} = this.state;

    if (_.isEmpty(currentOrg)) {
      return (
        <Grid.Column>
          <h4>{'No organization'}</h4>
        </Grid.Column>
      );
    }

    return (
      <Grid.Column>
        <h4>{currentOrg.displayName}</h4>
      </Grid.Column>
    );
  };

  getUEIFormatting = (currentOrg) => {
    const eft = _.trim(_.get(currentOrg, 'eft'));
    return _.get(currentOrg, 'uei') + (!_.isEmpty(eft) ? '-' + eft : '');
  };

  render() {
    const {validationErrors, validationDirtyMap, toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const {loading, currentOrg, error} = this.state;
    if (error) {
      return '';
    }
    const mailingAddress = _.get(currentOrg, 'mailingAddress', {});
    const physicalAddress = _.get(currentOrg, 'physicalAddress', {});

    const isDirty = (fieldNamePath) =>
      _.get(validationDirtyMap, 'dirtyPage', false) ||
      _.get(validationDirtyMap, ['dirty', ...fieldNamePath], false);

    return (
      <Segment>
        <Header as="h2" id="SAM.gov profile">
          System for Award Management (SAM.gov) profile
        </Header>
        <p>
          Please identify your organization to be associated with this application. <br />
          All organization information in this section will come from the System for Award
          Management (SAM) profile for that organization.
        </p>

        <Form id="SamGovProfileForm">
          {loading ? (
            <Grid.Column width={12}>
              <Loader inline="centered" active content="Loading" />
            </Grid.Column>
          ) : (
            <Grid
              key="orgSamGovApplicationGrid"
              stackable
              reversed="mobile"
              padded="vertically"
            >
              <Grid.Row key="orgDropDown">{this.renderOrg()}</Grid.Row>
              {!_.isEmpty(currentOrg) ? (
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={12} computer={12}>
                    <ItemGroup>
                      <NameValue
                        name="Information current from SAM.gov as of:"
                        data={ISOToDisplayDate(_.get(currentOrg, 'modifyDate'), {
                          showDate: true,
                        })}
                        defaultText="N/A"
                      />
                      {(dunsToUEIToggle || _.get(currentOrg, 'uei')) && (
                        <NameValue
                          name="UEI-EFT:"
                          data={
                            _.get(currentOrg, 'uei')
                              ? this.getUEIFormatting(currentOrg)
                              : ''
                          }
                        />
                      )}
                      <NameValue
                        name="DUNS (includes DUNS+4):"
                        data={
                          _.get(currentOrg, 'duns') +
                          (!_.isNil(_.get(currentOrg, 'dunsPlus4'))
                            ? _.get(currentOrg, 'dunsPlus4')
                            : '')
                        }
                      />
                      <NameValue
                        name="Employer Identification Number (EIN):"
                        data={_.get(currentOrg, 'ein')}
                      />
                      <NameValue
                        name="Organization legal name:"
                        data={_.get(currentOrg, 'legalName')}
                      />
                      <NameValue
                        name="Organization (doing business as) name:"
                        data={_.get(currentOrg, 'dba')}
                      />
                      <NameValue
                        name="Mailing address:"
                        data={
                          _.get(mailingAddress, 'streetLine1') +
                          ' ' +
                          _.get(mailingAddress, 'streetLine2') +
                          ' ' +
                          _.get(mailingAddress, 'city') +
                          ', ' +
                          _.get(mailingAddress, 'state') +
                          ' ' +
                          _.get(mailingAddress, 'zip') +
                          '-' +
                          _.get(mailingAddress, 'zipPlus4')
                        }
                      />
                      <NameValue
                        name="Physical address:"
                        data={
                          _.get(physicalAddress, 'streetLine1') +
                          ' ' +
                          _.get(physicalAddress, 'streetLine2') +
                          ' ' +
                          _.get(physicalAddress, 'city') +
                          ', ' +
                          _.get(physicalAddress, 'state') +
                          ' ' +
                          _.get(physicalAddress, 'zip') +
                          '-' +
                          _.get(physicalAddress, 'zipPlus4')
                        }
                      />
                      <NameValue
                        name="Is your organization delinquent on any federal debt?"
                        data={_.get(currentOrg, 'debtSubjectToOffset', '')}
                        defaultText="N/A"
                      />
                      {_.toLower(_.get(currentOrg, 'debtSubjectToOffset', '')) === 'y' ? (
                        <InlineTextAreaField
                          title="Please provide an explanation in the space provided"
                          label="Please provide an explanation in the space provided"
                          name="delinquentExplanation"
                          size="extralarge"
                          value={_.get(
                            this.state,
                            ['model', 'isDelinquent', 'explanation'],
                            ''
                          )}
                          maxLength={'4000'}
                          handleChange={(event) => {
                            const {model} = this.state;
                            let modelcopy = produce(model, (draft) => {
                              _.set(
                                draft,
                                ['isDelinquent', 'explanation'],
                                event.target.value
                              );
                            });
                            this.setState({model: modelcopy});
                          }}
                          handleBlur={() =>
                            this.saveSamGovInfo('isDelinquent.explanation')
                          }
                          displayError={
                            isDirty(['isDelinquent', 'explanation']) &&
                            _.get(validationErrors, [1, 'isValid']) === false
                          }
                          errorMessages={_.get(validationErrors, [1, 'message'])}
                        />
                      ) : (
                        ''
                      )}
                      <NameValue
                        name="SAM.gov registration status:"
                        data={`${_.get(
                          currentOrg,
                          'samRegistrationStatus.name'
                        )} as of ${ISOToDisplayDate(
                          _.get(currentOrg, 'samLastUpdateDate'),
                          {showDate: true}
                        )}`}
                        defaultText="N/A"
                      />
                      <Checkbox
                        title="bankAccountReviewCheck"
                        name="bankAccountReviewCheck"
                        id="bankAccountReviewCheck"
                        key="bankAccountReviewCheck"
                        checked={_.get(
                          this.state,
                          ['model', 'bankAccountReviewCheck'],
                          false
                        )}
                        label="We have reviewed our bank account information on our SAM.gov profile to ensure it is up to date"
                        handleChange={(name, value) => {
                          this.handleBankReviewChange(name, value);
                        }}
                        displayError={
                          isDirty(['bankAccountReviewCheck']) &&
                          _.get(validationErrors, [0, 'isValid']) === false
                        }
                        errorMessages={_.get(validationErrors, [0, 'message'])}
                      />
                    </ItemGroup>
                  </Grid.Column>
                </Grid.Row>
              ) : (
                ''
              )}
            </Grid>
          )}
        </Form>
      </Segment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps)(connectDynamic(SamGovProfile));
